export default __webpack_public_path__ + "static/alternative-icon-a9122f41ab28253b1c778712920f303d.svg";